import PropTypes from 'prop-types';
import { VideoProps } from '../WebVideo/WebVideo';
export const VideoPropType = PropTypes.shape({
  ...VideoProps,
  title: PropTypes.string,
  description: PropTypes.string
});
export const RefPropType = PropTypes.shape({
  current: PropTypes.object
});